import React, { useEffect } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/HomePage";
import ContactUs from "./Pages/ContactUs/ContactUs";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

const ScrollToSection = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/" && hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100); // wait a moment for DOM to render
      }
    }
  }, [hash, pathname]);

  return null;
};
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};



function App() {
  return (
    <Router>
      <ScrollToSection />
<ScrollToTop />
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<ContactUs />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
